import $ from 'jquery';

$(window).on('load', function () {
    $(document).on('click', '[id="gdpr-check-all-modules*"]', function () {
        $(this).closest('.table').find('.module-cookies-chkbox:not(:checked)').trigger('click');
        $('.div_cookie_category #span_under_16').removeClass('all_checked').addClass('not_checked');
    });
});
